const article = {
  "article.title": "Guia do Basetao Spreadsheet: o que é e como usar",
  "article.meta.description":
    "Descubra o que é um Basetao Spreadsheet, o que você encontra dentro dele e como usá-lo para comparar produtos, vendedores e categorias ao pedir pelo Basetao.",
  "article.breadcrumb": "Guia do Spreadsheet",
  "article.h1": "Guia do Basetao Spreadsheet: o que é e como usar",

  "article.author": "Por:",
  "article.author.name": "Equipe editorial do Basetao Sheet",
  "article.published": "Publicado:",
  "article.updated": "Atualizado:",
  "article.date": "18 de agosto de 2026",

  "article.intro":
    "Um Basetao Spreadsheet é uma lista compartilhada e organizada de links de produtos, categorias, vendedores e notas que os compradores usam para encontrar e comparar itens pedidos pelo Basetao. Em resumo, ele transforma um catálogo amplo e disperso em um ponto de partida organizado que você pode filtrar, ordenar e compartilhar. Este guia explica o que normalmente há dentro dele, como lê-lo e como usá-lo para comprar de forma mais eficiente.",

  "article.toc.title": "Nesta página",
  "article.toc.1": "O que é um Basetao Spreadsheet?",
  "article.toc.2": "O que você encontra dentro",
  "article.toc.3": "Como usar um Basetao Spreadsheet",
  "article.toc.4": "Por que os compradores confiam em uma planilha",
  "article.toc.5": "Dicas para aproveitar ao máximo",
  "article.toc.6": "Perguntas frequentes",

  "article.s1.h2": "O que é um Basetao Spreadsheet?",
  "article.s1.p1":
    "O Basetao é um agente de compras que ajuda compradores fora da China a pedir em marketplaces como Taobao, Weidian e 1688, e a enviar esses itens internacionalmente. Um Basetao Spreadsheet é um recurso complementar: uma lista que alguém já criou e compartilhou, contendo links para produtos específicos, suas categorias, vendedores e notas úteis.",
  "article.s1.p2":
    "Pense nele como um mapa selecionado do catálogo, não como o catálogo em si. Em vez de buscar em centenas de páginas, você parte de um conjunto de itens que outros compradores já localizaram e, em muitos casos, verificaram. Isso economiza tempo e oferece uma forma mais focada de comparar suas opções.",

  "article.s2.h2": "O que você encontra dentro de um Basetao Spreadsheet",
  "article.s2.p1":
    "As planilhas variam, mas a maioria das bem-feitas se baseia em algumas colunas consistentes. Veja o que cada coluna significa e por que ajuda.",
  "article.s2.table.c1": "Coluna",
  "article.s2.table.c2": "O que mostra",
  "article.s2.table.c3": "Por que ajuda",
  "article.s2.r1.c1": "Produto",
  "article.s2.r1.c2": "O item específico e seu link",
  "article.s2.r1.c3": "Ir direto ao item que você quer",
  "article.s2.r2.c1": "Categoria",
  "article.s2.r2.c2": "A que grupo o item pertence",
  "article.s2.r2.c3": "Filtrar tênis, moletons, bolsas e mais",
  "article.s2.r3.c1": "Vendedor",
  "article.s2.r3.c2": "O nome da loja ou do vendedor",
  "article.s2.r3.c3": "Identificar vendedores confiáveis que você reconhece",
  "article.s2.r4.c1": "Notas / QC",
  "article.s2.r4.c2": "Controle de qualidade e outras observações",
  "article.s2.r4.c3": "Evitar problemas antes de pedir",

  "article.s3.h2": "Como usar um Basetao Spreadsheet",
  "article.s3.p1":
    "Você não precisa de ferramentas especiais para usar uma planilha. Siga estes quatro passos para ir de uma lista a um pedido seguro.",
  "article.s3.step1.title": "1. Comece por uma categoria",
  "article.s3.step1.text":
    "Filtre a planilha pela categoria que você quer — tênis, camisetas, jaquetas, bolsas ou acessórios — para ver apenas as linhas relevantes.",
  "article.s3.step2.title": "2. Confira as notas",
  "article.s3.step2.text":
    "Leia as notas de vendedores e controle de qualidade ligadas a um produto. Elas costumam destacar detalhes de tamanho, qualidade ou envio.",
  "article.s3.step3.title": "3. Abra o link do produto",
  "article.s3.step3.text":
    "Use o link do produto para ver o item no site principal e confirmar preço, fotos e disponibilidade antes de se comprometer.",
  "article.s3.step4.title": "4. Compare antes de comprar",
  "article.s3.step4.text":
    "Coloque dois ou três itens semelhantes lado a lado para comparar vendedores e detalhes, e escolha o que melhor atende você.",

  "article.s4.h2": "Por que os compradores confiam em uma planilha",
  "article.s4.p1":
    "O principal motivo é simples: uma planilha elimina a maior parte da fricção de navegar. Em vez de abrir página após página e tentar lembrar o que você viu, você obtém uma visão única e ordenável de produtos, categorias, vendedores e notas. Isso é especialmente útil quando você está começando a usar um agente de compras, porque a lista oferece um ponto de partida já organizado, e as notas podem ajudar a evitar erros comuns como ignorar o tamanho ou escolher um vendedor pouco confiável.",

  "article.s5.h2": "Dicas para aproveitar ao máximo",
  "article.s5.p1": "Tenha estes hábitos em mente para que a planilha trabalhe mais por você.",
  "article.s5.t1": "Verifique antes de pedir — links e preços podem mudar; confirme sempre o item na página do produto.",
  "article.s5.t2": "Use as categorias para restringir sua busca em vez de rolar a lista inteira.",
  "article.s5.t3": "Adicione suas próprias notas enquanto compara para manter sua seleção organizada.",
  "article.s5.t4": "Marque como favorito os itens de que você gosta para voltar depois.",

  "article.s6.h2": "Perguntas frequentes",
  "article.s6.q1": "Preciso de uma conta Basetao para usar a planilha?",
  "article.s6.a1":
    "Não. Você pode ler e usar a planilha livremente. Só precisa de uma conta se decidir pedir por um agente de compras ou pelo site principal.",
  "article.s6.q2": "Os produtos da planilha estão sempre disponíveis?",
  "article.s6.a2":
    "Disponibilidade, preços e dados dos vendedores podem mudar com o tempo. A planilha é um bom ponto de partida, mas confirme sempre os detalhes atuais na página do produto.",

  "article.s7.h2": "Considerações finais",
  "article.s7.p1":
    "Um Basetao Spreadsheet é uma das formas mais simples de comprar por um agente de compras sem começar do zero. Ao oferecer uma lista estruturada de produtos, categorias, vendedores e notas, ele ajuda você a economizar tempo, comparar com mais facilidade e tomar decisões mais seguras. Comece por uma categoria, confira as notas e verifique a página do produto antes de comprar.",

  "article.cta.text": "Pronto para navegar? Explore todo o catálogo no site principal.",
  "article.cta.button": "Comprar agora",
  "article.backHome": "Voltar ao início",
};

export default article;